
<template>
    <div>
        <div class="mcc-page-header">
            <div class="mu-d-flex mu-flex-row">

                <h1 class="mu-mb-00">Role details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

            </div>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb" >
                <ol class="mcc-breadcrumb">
                    <li>Users & groups</li>

                    <li>
                        <a class="table-link" @click="redirectToList()">Roles</a>
                    </li>
                    <li aria-current="page">{{roleName}}</li>
                    <li class="lastBredCrumpLi">

                    </li>
                </ol>
            </nav>
          <div class="mcc-card"><div class="mcc-card__body">
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>
            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <div v-if="fetchCall">
                
                        <form novalidate ref="roleForm" id="roleForm" @submit.prevent="saveRole()">

                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Details</h2>
                                </div>

                                <div class="mcc-card__body">
                                    
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                <label for="name" class="mfc-label--required">Name</label>
                                                <input type="text" readonly="" id="name" name="name" required="" placeholder="Name"  ref="name" :value="roleName">

                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-container  mfc-form-input-wrapper--width" v-if="isAdvancedSSO" >
                                                <label for="description">Description</label>
                                                <textarea readonly="" id="description" name="description" maxlength="255" ref="description" placeholder="Description" :value="dto.description" :pattern="descRegex" character-count=""></textarea>
                                                <div class="mfc-invalid-feedback"></div>
                                                <div class="mfc-help-text mu-mt-00">
                                            
                                        <span>You have {{100 - dto.description.length}} characters remaining</span>
                                    </div>
                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-container   mfc-form-input-wrapper--width" v-else>
                                                <label for="description">Description</label>
                                                <textarea id="description" name="description" maxlength="255"  ref="description" placeholder="Description" :value="dto.description" :pattern="descRegex" @change="updateDescription($event)" character-count=""></textarea>
                                                <div class="mfc-invalid-feedback"></div>
                                                <div class="mfc-help-text mu-mt-00">
                                       <span>You have {{100 - dto.description.length}} characters remaining</span>
                                    </div>
                                            </div>
                                            

                                        </div>

                                    

                            </div>
                       

                   
                        <div class="mcc-card mu-mt-05">
                            <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                <div>
                                    <h2 class="mcc-card__title">Users</h2>
                                </div>
                            
                            </div>
                            <div class="mcc-card__body" id="rolesEditCardBody">
                                <mfc-form prevent-default="">
                                    <Picklist  ref="userList" label=" " id="userList" name="userList" multiple filter>
                                    </Picklist>
                                </mfc-form>
                            </div>

                        </div>
                        <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end mu-mt-05" >
                            <div class="mcc-button-group mcc-button-group--spaced">
                            <button class="mcc-button mcc-button--outline" title="Save" id="saveBtn" @click="$router.go(-1)" type="button">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                </button>
                                                <button  class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit">
                                                    <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                </button>
                                            </div>
                                            </div> </form>
                   

                </div>
            </div>
        </div></div></div>

    </div>
</template>

<script>
import RoleAPI from "../../../services/RoleAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import Picklist from "../../customComponents/Picklist.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage,checkFormAndTextareaValidations
} from '../../../formvalid.js';
export default {
    name: "RoleEdit",
    components:
    {
        Picklist
    },
    data() {
        return {
            dto: {
                name: '',
                description: ''
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            descRegex: constantMessages.PATTERNS["description"],
            helpText: constantMessages.BREADCRUMB_HELP["role.edit"],
            roleName: this.$route.params.roleName,
            dataLoaded: false,
            fetchCall: false,
            showData: false,
            updateCall: true,
            isAdvancedSSO: false

        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        var self = this;
        self.fetchCall = false;

        RoleAPI.getRoleInfo(self.roleName)
            .then(result => {
                self.dataLoaded = true;
                self.dto = result;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.role.details"] + " - " + self.roleName;
                EventBus.$emit("update-pageTitle", pageTitle);
            }).finally(() => {
                self.fetchCall = true;
                self.loadUers();
            });

        this.isAdvancedSSO = self.$store.getters.getIsAdvancedSSO;

    },
    methods: {
        async loadUers(users) {
            var self = this;
            self.updateCall = false;
            await this.$nextTick();
            setTimeout(function () {
                self.setDisableArray();
            }, 2000);
        },
        setDisableArray() {
            var self = this;
            let userArray = [];
            let assignedUsers = [];
            let roleUser = self.roleName == "ROLE_USER";
            $.each(self.dto.allUsers, function (key, value) {
                let disabledEnt = false;
                if (roleUser) {
                    $.each(self.dto.userNamesInRole, function (assignedKey, assignedValue) {
                        if (value == assignedValue) {
                            disabledEnt = true;
                        }
                    })
                }
                userArray.push({
                    "text": value,
                    "disabled": disabledEnt
                });
            });
            $.each(self.dto.parentRoleUserNames, function (key, value) {
                userArray.push({
                    "text": value,
                    "disabled": true
                });
                assignedUsers.push(value);
            });

            $.each(self.dto.userNamesInRole, function (key, value) {
                assignedUsers.push(value);
            });
            self.$refs.userList.setData(userArray,assignedUsers);
            self.updateCall = true;
        },
        saveRole() {
            let self = this;
            let form = $('#roleForm')
            
            if (this.dto.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form))
            {
                return;
            }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }     
            self.updateCall = false;
            let newRoles = self.$refs.userList.value;
            let oldRoles = self.dto.userNamesInRole;

            $.each(self.dto.parentRoleUserNames, function (key, value) {
                oldRoles.push(value);
            });

            let addedRecords = newRoles.filter(x => !oldRoles.includes(x));
            let removedRecords = oldRoles.filter(x => !newRoles.includes(x));
            self.dto.removedUsers = removedRecords;
            self.dto.addedUsers = addedRecords
            RoleAPI.saveRole(self.dto)
                .then(response => {

                    if (response.error) {
                        self.updateCall = true;
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.dto = response.data;
                        self.setDisableArray();
                    }
                });
        },
        updateDescription(event) {
            var self = this;
            self.dto.description = event.target.value;
        },
        redirectToList() {
            this.$router.push(
                this.CONTEXT_PATH + '/usersgroups/roles'
            );
        }
    }
}
</script>
